import type { InventoryResource } from '@repo/api-gw-sdk';

const sqlServerAppName = 'Microsoft SQL Server';

export const sqlServerVersionOf = (
  entity: InventoryResource
): string | undefined =>
  entity.classifications?.appsDetails?.apps?.find(
    (app) => app.name === sqlServerAppName
  )?.version;

export const sqlServerVersionLabel = (
  entity: InventoryResource
): string | undefined => {
  const version = sqlServerVersionOf(entity);

  return version ? `SQL Server ${version}` : undefined;
};
